import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
export function WorkMirrorFirstEntry() {
  const navigate = useNavigate();
  const [entry, setEntry] = useState('');
  const handleSave = () => {
    if (entry.trim()) {
      // Save entry logic here
      console.log('Saving entry:', entry);
      // Navigate back to app home
      navigate('/work-mirror/app');
    }
  };
  const handleCancel = () => {
    navigate('/work-mirror/app');
  };
  return <>
      <Helmet data-id="element-4069">
        <title data-id="element-4070">New Entry | Work Mirror</title>
        <meta name="robots" content="noindex, nofollow" data-id="element-4071" />
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]" data-id="element-4072">
        {/* Top Bar */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A] border-b border-[#2B2B2B]" data-id="element-4073">
          <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-4074">
            <button onClick={handleCancel} className="text-sm text-gray-500 hover:text-gray-400 transition-colors" data-id="element-4075">
              Cancel
            </button>

            <p className="text-xs font-mono text-gray-600 uppercase tracking-wider" data-id="element-4076">
              New entry
            </p>

            <button onClick={handleSave} disabled={!entry.trim()} className="text-sm text-[#F5F5F5] hover:text-gray-400 transition-colors disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:text-[#F5F5F5]" data-id="element-4077">
              Save
            </button>
          </div>
        </header>

        <main className="pt-24 pb-16 px-6" data-id="element-4078">
          <div className="max-w-2xl mx-auto space-y-12" data-id="element-4079">
            {/* Main Prompt */}
            <div className="space-y-4 pt-8" data-id="element-4080">
              <h1 className="text-2xl md:text-3xl font-light text-[#F5F5F5] leading-relaxed" data-id="element-4081">
                Note something from today that stayed with you.
              </h1>
              <p className="text-base text-gray-500 leading-relaxed" data-id="element-4082">
                For example: a meeting, a disagreement, a decision, or a moment
                at work.
              </p>
            </div>

            {/* Input Field */}
            <div className="space-y-4" data-id="element-4083">
              <textarea value={entry} onChange={e => setEntry(e.target.value)} placeholder="Had a tense meeting with X about Y. I pushed for a decision. There was resistance and the room went quiet." className="w-full min-h-[240px] p-6 bg-[#0A0A0A] border border-[#2B2B2B] text-[#F5F5F5] text-base leading-relaxed placeholder:text-gray-700 focus:outline-none focus:border-[#64748B] transition-colors resize-none" autoFocus data-id="element-4084" />

              {/* Optional Helper */}
              <p className="text-xs text-gray-600" data-id="element-4085">
                You don't need to explain everything. Just note what happened.
              </p>
            </div>
          </div>
        </main>
      </div>
    </>;
}